export var ICON_SIZE = {
  DEFAULT: 24,
  SMALL: 16
};